module.exports = __webpack_public_path__ + "img/qian_z.e278d820.png";